import { render, staticRenderFns } from "./_loading.vue?vue&type=template&id=62285142"
import script from "./_loading.vue?vue&type=script&lang=js"
export * from "./_loading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports